import { render, staticRenderFns } from "./BasePropertyForm.vue?vue&type=template&id=57d5a48e&scoped=true&"
import script from "./BasePropertyForm.vue?vue&type=script&lang=js&"
export * from "./BasePropertyForm.vue?vue&type=script&lang=js&"
import style0 from "./BasePropertyForm.vue?vue&type=style&index=0&id=57d5a48e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57d5a48e",
  null
  
)

export default component.exports